import { render, staticRenderFns } from "./RechargeGil.vue?vue&type=template&id=6b2f592f&scoped=true&"
import script from "./RechargeGil.vue?vue&type=script&lang=js&"
export * from "./RechargeGil.vue?vue&type=script&lang=js&"
import style0 from "./RechargeGil.vue?vue&type=style&index=0&id=6b2f592f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f592f",
  null
  
)

export default component.exports